// src/helpers/factories/homeScreenModulesArrayFactory.ts
var expectedModulesOrder = [
  "register" /* Register */,
  "menu" /* Menu */,
  "settings" /* Settings */,
  "report" /* Report */,
  "management" /* Management */,
  "customers" /* Customers */
];
var homeScreenAvailableModulesArrayFactory = (homeScreenPermissions) => {
  const moduleType = "ModuleAvailable";
  return getActiveModulesBasedOnPermissions(homeScreenPermissions, moduleType);
};
var homeScreenDefaultModulesArrayFactory = (homeScreenPermissions) => {
  const moduleType = "ModuleDefault";
  const defaultModules = getActiveModulesBasedOnPermissions(
    homeScreenPermissions,
    moduleType
  );
  const availableModules = homeScreenAvailableModulesArrayFactory(
    homeScreenPermissions
  );
  return defaultModules.filter(
    (defaultModule) => availableModules.includes(defaultModule)
  );
};
var getActiveModulesBasedOnPermissions = (homeScreenPermissions, moduleType) => {
  const homeScreenPermissionsTuple = Object.entries(homeScreenPermissions);
  const activeModules = homeScreenPermissionsTuple.filter(
    (property) => property[0].includes(moduleType) && property[1] === true
  );
  const moduleArray = activeModules.map((activeModule) => {
    return activeModule[0].replace(moduleType, "");
  });
  const orderedModuleArray = moduleArray.sort(
    (a, b) => (expectedModulesOrder.indexOf(a) !== -1 ? expectedModulesOrder.indexOf(a) : Infinity) - (expectedModulesOrder.indexOf(b) !== -1 ? expectedModulesOrder.indexOf(b) : Infinity)
  );
  return orderedModuleArray;
};

export { expectedModulesOrder, homeScreenAvailableModulesArrayFactory, homeScreenDefaultModulesArrayFactory };
